/** Initials for an avatar: both names when we have them, else a single letter. */
export function getInitials(firstName?: string, lastName?: string, fallback?: string): string {
  const initials = `${firstName?.trim()[0] ?? ''}${lastName?.trim()[0] ?? ''}`;
  return (initials || fallback?.trim()[0] || '?').toUpperCase();
}

export default getInitials;
